import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { HeaderComponent } from './pages/header/header.component';
import { FooterComponent } from './pages/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { RouterModule, Routes} from "@angular/router";
import { LoginComponent } from './pages/login/login.component';
import {FormsModule} from "@angular/forms";
import {AuthService} from "./services/auth.service";
import { DocComponent } from './pages/doc/doc.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import {AgmCoreModule} from "@agm/core";


export const routes: Routes = [
  {
    path: "home",
    component: HomeComponent,
    canActivate: [
      AuthService
      ]
  },
  {
    path: "login",
    component: LoginComponent
  },
  {
    path: "doc",
    component: DocComponent
  },
  {
    path: "contact-us",
    component: ContactUsComponent
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: "home"
  },
  {
    path: "seedit.com.gh",
    pathMatch: "full",
    redirectTo: "home"
  }
];

export const MAP_API_KEY = "AIzaSyB_sm98t8Y4bRTX9R7vM30-zSm3UMxTMjc";

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    HomeComponent,
    LoginComponent,
    DocComponent,
    ContactUsComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    AgmCoreModule.forRoot({
      apiKey: MAP_API_KEY
    }),
    RouterModule.forRoot(routes)
  ],
  providers: [
    AuthService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/bright.ofosu/Documents/brytelabs/seedit-parent/seedit-website/src/app/app.module.ts